/* KX_VIDEO_PRODUCTS_ROW_20260811 */

(function () {
  function initVideoProductsRows(root) {
    var scope = root || document;

    scope.querySelectorAll('[data-kx-vpr-block]').forEach(function (block) {
      if (block.dataset.kxVprReady === '1') return;
      block.dataset.kxVprReady = '1';

      /* KX_VPR_AUTO_VIDEO_RATIO_20260811 */
      var videoPanel = block.querySelector('[data-kx-vpr-video-panel]');

      if (
        videoPanel &&
        videoPanel.dataset.kxVprRatioMode === 'auto'
      ) {
        var videoElement = videoPanel.querySelector('video');

        if (videoElement) {
          var applyNativeVideoRatio = function () {
            if (videoElement.videoWidth > 0 && videoElement.videoHeight > 0) {
              videoPanel.style.setProperty(
                '--kx-vpr-video-ratio',
                videoElement.videoWidth + ' / ' + videoElement.videoHeight
              );
            }
          };

          if (videoElement.readyState >= 1) {
            applyNativeVideoRatio();
          } else {
            videoElement.addEventListener(
              'loadedmetadata',
              applyNativeVideoRatio,
              { once: true }
            );
          }
        }
      }

      var shell = block.querySelector('[data-kx-vpr-shell]');
      var row = block.querySelector('[data-kx-vpr-scroll]');
      var prev = block.querySelector('[data-kx-vpr-prev]');
      var next = block.querySelector('[data-kx-vpr-next]');
      var counter = block.querySelector('[data-kx-vpr-counter]');

      if (!shell || !row || !prev || !next) return;

      function getMetrics() {
        var pageWidth = Math.max(1, row.clientWidth);
        var maxScroll = Math.max(0, row.scrollWidth - row.clientWidth);
        var pages = Math.max(1, Math.ceil(row.scrollWidth / pageWidth));
        var current = Math.min(
          pages,
          Math.max(1, Math.round(row.scrollLeft / pageWidth) + 1)
        );

        return {
          pageWidth: pageWidth,
          maxScroll: maxScroll,
          pages: pages,
          current: current
        };
      }

      function update() {
        var m = getMetrics();
        var tolerance = 4;

        prev.hidden = row.scrollLeft <= tolerance;
        next.hidden = row.scrollLeft >= (m.maxScroll - tolerance);

        if (counter) {
          counter.textContent = 'Page ' + m.current + ' of ' + m.pages;
        }
      }

      function move(direction) {
        var m = getMetrics();

        row.scrollBy({
          left: direction * m.pageWidth,
          behavior: 'smooth'
        });

        window.setTimeout(update, 350);
      }

      prev.addEventListener('click', function () {
        move(-1);
      });

      next.addEventListener('click', function () {
        move(1);
      });

      row.addEventListener('scroll', function () {
        window.requestAnimationFrame(update);
      }, { passive: true });

      window.addEventListener('resize', update);

      update();
      window.setTimeout(update, 200);
    });
  }

  function initDocument() {
    initVideoProductsRows(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initDocument);
  } else {
    initDocument();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initVideoProductsRows(event.target);
  });

  document.addEventListener('shopify:block:select', function (event) {
    initVideoProductsRows(event.target.closest('.shopify-section') || document);
  });
})();